module.exports = __webpack_public_path__ + "img/blob.2f6a7c04.svg";